import { useGetCommissionsMetricsQuery } from '@/affiliate-dashboard/graphql';
import { Label } from '@/components/base/label';
import { Loading } from '@/components/base/loading';
import { PageHeading } from '@/components/base/page-heading';
import Section from '@/components/base/section';
import { faCalendar, faDollar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';

export function Overview(): JSX.Element {
  const intl = useIntl();
  const { t } = useTranslation();
  const { data: commissionsMetrics, loading } = useGetCommissionsMetricsQuery();

  return (
    <div className="flex flex-col gap-5">
      <PageHeading subheading={t('commissions.overview.subtitle')}>
        {t('commissions.overview.title')}
      </PageHeading>
      <div className="grid gap-4 md:grid-cols-3">
        <Section variant="secondary">
          <div className="flex w-full flex-col gap-4">
            <div className="flex w-full items-center gap-3">
              <Label className="flex items-center justify-center">
                <FontAwesomeIcon className="h-5 w-6" icon={faDollar} />
              </Label>
              <span>{t('commissions.overview.commissions')}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold">
                {loading ? (
                  <Loading />
                ) : (
                  intl.formatNumber(
                    commissionsMetrics?.commissionsMetrics
                      ?.totalCommissionsAmount ?? 0,
                    {
                      style: 'currency',
                      currency: 'USD',
                      maximumFractionDigits: 2,
                    },
                  )
                )}
              </span>
            </div>
          </div>
        </Section>
        <Section variant="secondary">
          <div className="flex w-full flex-col gap-4">
            <div className="flex w-full items-center gap-3">
              <Label className="flex items-center justify-center">
                <span className="fa-layers fa-fw h-5 w-6">
                  <FontAwesomeIcon icon={faCalendar} className="h-6 w-6" />
                  <FontAwesomeIcon
                    icon={faDollar}
                    className="h-3 w-4 pt-[0.3rem]"
                  />
                </span>
              </Label>
              <span>{t('commissions.overview.commissionsThisMonth')}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold">
                {loading ? (
                  <Loading />
                ) : (
                  intl.formatNumber(
                    commissionsMetrics?.commissionsMetrics
                      ?.totalCommissionsAmountThisMonth ?? 0,
                    {
                      style: 'currency',
                      currency: 'USD',
                      maximumFractionDigits: 2,
                    },
                  )
                )}
              </span>
            </div>
          </div>
        </Section>
      </div>
    </div>
  );
}
